export enum DBCollectionName {
  HIGHLIGHTS = 'lnfp_highlights',
  JORNADAS_HIGHLIGHTS = 'lnfp_jornadas_highlights',
  NEWS = 'lnp_news',
  RERSERVES_TOURNAMENT = 'lnfp_reserves_tournaments',
  USERS = 'lnp_users',
  JORNADAS_CALENDAR = 'lnp_jornadas',
  VOTING_CENTER = 'lnfp_voting_center',
}
